const x = {
  body: "Founders Grotesk, sans-serif",
  heading: "Founders Grotesk, sans-serif"
}, s = {
  "2xs": "10px",
  xs: "11px",
  sm: "12px",
  md: "14px",
  lg: "16px",
  xl: "18px",
  "2xl": "20px",
  "3xl": "24px",
  "4xl": "28px",
  "5xl": "36px",
  "6xl": "48px"
};
export {
  s as fontSizes,
  x as fonts
};
//# sourceMappingURL=typography.es.js.map
